import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=5c97a296&scoped=true&"
import script from "./BrandItem.vue?vue&type=script&lang=js&"
export * from "./BrandItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=5c97a296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97a296",
  null
  
)

export default component.exports